import React from 'react';
import { Award, Download, Search, Check, Clock } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const AdminCertificatesPage = () => {
  return (
    <div className="space-y-6" data-testid="admin-certificates-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Certificates</h1>
          <p className="text-slate-500 mt-1">Manage and issue certificates</p>
        </div>
        <Button className="bg-blue-600 hover:bg-blue-700 gap-2">
          <Award className="w-4 h-4" />
          Issue Certificate
        </Button>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <div className="bg-white rounded-xl p-5 border border-slate-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
              <Check className="w-5 h-5 text-emerald-600" />
            </div>
            <div>
              <p className="text-sm text-slate-500">Issued</p>
              <p className="text-xl font-bold text-slate-900">2,450</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-xl p-5 border border-slate-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-amber-100 rounded-lg flex items-center justify-center">
              <Clock className="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <p className="text-sm text-slate-500">Pending</p>
              <p className="text-xl font-bold text-slate-900">89</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-xl p-5 border border-slate-200">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
              <Download className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <p className="text-sm text-slate-500">Downloaded</p>
              <p className="text-xl font-bold text-slate-900">1,890</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-md">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <Input placeholder="Search by certificate ID or student name..." className="pl-10" />
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full">
          <thead className="bg-slate-50">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-medium text-slate-600">Certificate ID</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-slate-600">Student</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-slate-600">Course</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-slate-600">Issue Date</th>
              <th className="px-4 py-3 text-left text-sm font-medium text-slate-600">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {[
              { id: 'CERT-2026-001', student: 'Rahul Kumar', course: 'DCA', date: '2026-04-01' },
              { id: 'CERT-2026-002', student: 'Priya Sharma', course: 'CCC', date: '2026-03-28' },
              { id: 'CERT-2026-003', student: 'Amit Singh', course: 'TALLY', date: '2026-03-25' },
            ].map((cert) => (
              <tr key={cert.id} className="hover:bg-slate-50">
                <td className="px-4 py-3 font-mono text-sm text-blue-600">{cert.id}</td>
                <td className="px-4 py-3 font-medium text-slate-900">{cert.student}</td>
                <td className="px-4 py-3 text-slate-600">{cert.course}</td>
                <td className="px-4 py-3 text-slate-500">{cert.date}</td>
                <td className="px-4 py-3">
                  <Button variant="ghost" size="sm">
                    <Download className="w-4 h-4" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminCertificatesPage;
